const appConfig = {
  // apiPrefix: "http://localhost:5005/api/",
  apiPrefix: "https://mastererpapi.5techg.com/api/",
  authenticatedEntryPath: "/dashboard",
  unAuthenticatedEntryPath: "/sign-in",
  tourPath: "/",
  locale: "en",
  enableMock: true,
};

export default appConfig;
